<template>
  <div id="app">
    <slidebar />
    <router-view />
    <mv-footer />
  </div>
</template>

<script>

import Slidebar from '@/layout/components/Sidebar/index.vue'
import MvFooter from '@/components/MvFooter/index.vue'

export default {
  name: 'App',
  components: { MvFooter, Slidebar }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
</style>
